// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3e0471a3","455":"e5a14bef","977":"5f7a94ea"}[chunkId] + ".chunk.js";
};